import * as z from "zod";

/**
 * Self-serve enable of the Supplies storefront for the calling team — flips
 * `settings.outboundLabels.showSuppliesStorefront` to true.
 */
export const enableSuppliesStorefront = {
  name: "enableSuppliesStorefront" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
